import React, { useEffect, useState } from "react";
import { useUser } from "@services/UserContext";
import { apiBaseUrl } from "@constants";

declare global {
  interface Window {
    OneDrive?: any;
  }
}
export const useOneDrivePicker = ({
  openDrivePicker,
}: {
  openDrivePicker: () => void;
}) => {
  const { googleDriveToken, setGoogleDriveToken } = useUser(); // Keep consistent pattern
  const [onedriveToken, setOneDriveToken] = useState<string | null>(null);

  const BACKEND = apiBaseUrl;

  // ✅ Load OneDrive Picker SDK once
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.live.net/v7.2/OneDrive.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // ✅ Fetch short-lived token from backend
  const getPickerToken = async () => {
    const res = await fetch(`${BACKEND}/onedrive/picker-token/`, {
      credentials: "include",
    });
    const data = await res.json();
    return data.access_token;
  };

  // ✅ On mount, try to get token
  useEffect(() => {
    (async () => {
      try {
        const token = await getPickerToken();
        setOneDriveToken(token);
      } catch (error) {
        console.error("Failed to fetch OneDrive token:", error);
      }
    })();
  }, []);

  // ✅ Start OAuth if user is not connected
  const connectOneDrive = async () => {
    const res = await fetch(`${BACKEND}/onedrive/auth-url/`, {
      credentials: "include",
    });
    const data = await res.json();
    window.location.href = data.auth_url;
  };

  // ✅ Launch OneDrive Picker
  const validateAndOpenOneDrivePicker = async () => {
    if (!onedriveToken) {
      await connectOneDrive();
      return;
    }
    openDrivePicker();
  };

  return { validateAndOpenOneDrivePicker };
};
